module.exports = __webpack_public_path__ + "img/MuayThaiChampion_FreeSpinsFeature_TotalWinSettlement.fea3cebc.jpg";